// Part of taxPages, split to keep files short; ../taxPages.ts merges the parts. Keys sit directly under taxPages.
export const en = {
  vatRates: {
    titleIndia: 'Tax rates',
    titleUae: 'VAT',
    descriptionIndia:
      'GST codes used on transactions: rate, CGST + SGST or IGST, and the GSTR-1 / GSTR-3B category.',
    descriptionUae: 'UAE VAT codes used on transactions and the VAT 201 box each one reports to.',
    newTaxRate: 'New tax rate',
    filterPlaceholder: 'Filter by code or name',
    filterLabel: 'Filter tax rates',
    includeInactive: 'Include inactive',
    loadError: 'Could not load tax rates',
    noMatch: 'No tax rates match your filter',
    col: {
      code: 'Code',
      name: 'Name',
      rate: 'Rate',
      kind: 'Kind',
      appliesTo: 'Applies to',
      returnCategory: 'Return category',
      returnBox: 'Return box',
      effectiveFrom: 'Effective from',
      status: 'Status',
      action: 'Action',
    },
    usedOnTransactions: 'Used on transactions',
    usedTooltip: 'Used on transactions: the rate and kind are fixed.',
    notReported: 'Not reported',
    notReportedBlocked: 'Not reported (blocked credit)',
    active: 'Active',
    moreActions: 'More actions for {{code}}',
    makeInactive: 'Make inactive',
    makeActive: 'Make active',
    inactiveNote: 'Inactive codes stay on the transactions that used them and drop out of pickers.',
    toastActive: '{{code}} is active again.',
    toastInactive: '{{code}} is now inactive.',
    toastSaved: 'Tax rate {{code}} saved.',
    editTitle: 'Edit tax rate {{code}}',
    lockedHint: 'Used on transactions: the rate and kind are fixed. Add a new code for a new rate.',
    drawerHint: 'Rates and VAT 201 boxes are data, so they can be corrected without a release.',
    ratePercent: 'Rate (%)',
    returnCategoryHint: 'GSTR-1 table and GSTR-3B row.',
    taxSplit: 'Tax split',
    taxSplitHint: 'Intra-state: CGST + SGST; inter-state: IGST.',
    splitNone: 'None (nil, exempt, non-GST, exports)',
    vat201Box: 'VAT 201 box',
    description: 'Description',
    applies: {
      sales: 'Sales',
      purchases: 'Purchases',
      both: 'Sales and purchases',
    },
    kind: {
      standard: 'Standard rated',
      zero: 'Zero rated',
      exempt: 'Exempt',
      outOfScope: 'Out of scope',
      reverseCharge: 'Reverse charge',
    },
    gstCategory: {
      TAX: 'Taxable',
      EXP: 'Export (zero rated)',
      NIL: 'Nil rated',
      EXEMPT: 'Exempt',
      NONGST: 'Non-GST',
      RCM: 'Reverse charge',
    },
    box: {
      b1: '1a–1g · Standard-rated supplies (by emirate)',
      b2: '2 · Tax refunds to tourists',
      b3: '3 · Supplies subject to reverse charge',
      b4: '4 · Zero-rated supplies',
      b5: '5 · Exempt supplies',
      b6: '6 · Goods imported into the UAE',
      b7: '7 · Adjustments to goods imported',
      b9: '9 · Standard-rated expenses',
      b10: '10 · Reverse charge (recoverable)',
    },
  },
  eInvoicing: {
    title: 'E-invoicing',
    description:
      'Invoices and credit notes sent through the service provider, and what needs fixing.',
    offTitle: 'E-invoicing is off for this company',
    offHint: 'Your accountant switches it on in Company settings, on the Sales tab.',
    companySettings: 'Company settings',
    statusLabel: 'Status',
    searchPlaceholder: 'Search by number, customer or reference',
    searchLabel: 'Search e-invoices',
    loadError: 'Could not load e-invoices',
    noExceptions: 'No exceptions',
    noExceptionsHint: 'Every e-invoice was accepted or is on its way.',
    noMatch: 'No e-invoices match these filters',
    col: {
      date: 'Date',
      number: 'No.',
      customer: 'Customer',
      total: 'Total',
      einvoice: 'E-invoice',
      details: 'Details',
      lastUpdate: 'Last update',
      action: 'Action',
    },
    creditNote: 'Credit note',
    invoice: 'Invoice',
    deliveryFailed_one: 'Delivery failed {{count}} time: {{error}}',
    deliveryFailed_other: 'Delivery failed {{count}} times: {{error}}',
    retrying: 'Retrying: {{error}}',
    toastResubmitted: '{{number}} resubmitted.',
    toastQueued: '{{number}} queued again.',
    view: 'View',
  },
  einvoice: {
    resubmit: 'Resubmit',
    retryDelivery: 'Retry delivery',
    providerUnavailable: 'service provider unavailable',
    status: {
      needsAttention: 'Needs attention',
      notRequired: 'Not required',
      pending: 'Pending',
      submitted: 'Submitted',
      accepted: 'Accepted',
      rejected: 'Rejected',
    },
    filter: {
      exceptions: 'Exceptions',
      all: 'All',
    },
    legalId: {
      TL: 'Trade licence',
      EID: 'Emirates ID',
      PAS: 'Passport',
      CD: 'Cabinet decision',
    },
    event: {
      queued: 'Queued on approval',
      approvedBy: 'Approved by {{name}}',
      notRequired: 'Not required',
      built: 'E-invoice built',
      builtVersion: 'E-invoice built (version {{version}})',
      passed: 'Passed validation',
      passedWithWarnings_one: 'Passed validation with {{count}} warning',
      passedWithWarnings_other: 'Passed validation with {{count}} warnings',
      validationErrors_one: '{{count}} validation error',
      validationErrors_other: '{{count}} validation errors',
      validationFailed: 'Rejected by validation',
      submitted: 'Submitted to the service provider',
      submittedVersion: 'Submitted to the service provider (version {{version}})',
      reference: 'Reference {{reference}}',
      deliveryFailed: 'Delivery attempt {{attempt}} failed',
      nextTry: 'Next try {{when}}',
      noMoreRetries: 'No more automatic retries',
      accepted: 'Accepted',
      rejected: 'Rejected by the service provider',
      resubmitted: 'Resubmitted',
      resubmittedBy:
        'By {{name}}. A new version is built from the current invoice and customer details.',
      resubmittedText: 'A new version is built from the current invoice and customer details.',
      retried: 'Delivery retried',
      by: 'By {{name}}',
      statusCheckFailed: 'Status check failed',
    },
    panel: {
      title: 'E-invoice',
      lockedInvoice:
        'This invoice can no longer be edited or voided; correct it with a credit note.',
      lockedCreditNote:
        'This credit note can no longer be edited or voided; correct it with a credit note.',
      timeline: 'Timeline',
      notRequired: 'No e-invoice is required for this document.',
      accepted: 'Accepted by the service provider, reference {{reference}}.',
      submitted: 'Submitted, reference {{reference}}; waiting for the outcome.',
      seeTimeline: 'See the timeline for the reason',
      needsAttention_one:
        'Delivery failed {{count}} time ({{error}}). Retry when the provider is back.',
      needsAttention_other:
        'Delivery failed {{count}} times ({{error}}). Retry when the provider is back.',
      retrying: 'Delivery failed; trying again.',
      retryingAt: 'Delivery failed; trying again at {{when}}.',
      queued: 'Queued; it is built, checked and sent within a minute.',
      downloadXml: 'Download XML',
      toastResubmitted: '{{number}} resubmitted. A new version is built from the current details.',
      toastRequeued: '{{number}} queued for delivery again.',
    },
    timeline: {
      titleInvoice: 'E-invoice for invoice {{number}}',
      titleCreditNote: 'E-invoice for credit note {{number}}',
      reference: 'Service provider reference {{reference}}.',
      description: 'Every step is kept, with each version that was built.',
      fixAndResubmit: 'Fix these and resubmit',
      providerSaid: 'The service provider said',
      versions: 'Versions',
      version: 'Version {{version}}',
      builtPassed: 'Built {{when}} · passed validation',
      builtErrors_one: 'Built {{when}} · {{count}} validation error',
      builtErrors_other: 'Built {{when}} · {{count}} validation errors',
    },
  },
};

export const ar = {
  vatRates: {
    titleIndia: 'نسب الضريبة',
    titleUae: 'ضريبة القيمة المضافة',
    descriptionIndia:
      'رموز ضريبة السلع والخدمات (GST) المستخدمة في المعاملات: النسبة، وCGST + SGST أو IGST، وفئة GSTR-1 / GSTR-3B.',
    descriptionUae:
      'رموز ضريبة القيمة المضافة في الإمارات المستخدمة في المعاملات، والخانة التي يُصرَّح عنها كل رمز في إقرار VAT 201.',
    newTaxRate: 'نسبة ضريبة جديدة',
    filterPlaceholder: 'تصفية حسب الرمز أو الاسم',
    filterLabel: 'تصفية نسب الضريبة',
    includeInactive: 'تضمين غير النشطة',
    loadError: 'تعذّر تحميل نسب الضريبة',
    noMatch: 'لا توجد نسب ضريبة مطابقة للتصفية',
    col: {
      code: 'الرمز',
      name: 'الاسم',
      rate: 'النسبة',
      kind: 'النوع',
      appliesTo: 'ينطبق على',
      returnCategory: 'فئة الإقرار',
      returnBox: 'خانة الإقرار',
      effectiveFrom: 'ساري اعتباراً من',
      status: 'الحالة',
      action: 'الإجراء',
    },
    usedOnTransactions: 'مستخدم في معاملات',
    usedTooltip: 'مستخدم في معاملات: النسبة والنوع ثابتان.',
    notReported: 'لا يُصرَّح عنه',
    notReportedBlocked: 'لا يُصرَّح عنه (رصيد ضريبي محظور)',
    active: 'نشط',
    moreActions: 'إجراءات أخرى للرمز {{code}}',
    makeInactive: 'تعطيل',
    makeActive: 'تفعيل',
    inactiveNote: 'تبقى الرموز غير النشطة على المعاملات التي استخدمتها، وتختفي من قوائم الاختيار.',
    toastActive: 'الرمز {{code}} نشط مجدداً.',
    toastInactive: 'الرمز {{code}} أصبح غير نشط.',
    toastSaved: 'تم حفظ نسبة الضريبة {{code}}.',
    editTitle: 'تعديل نسبة الضريبة {{code}}',
    lockedHint: 'مستخدم في معاملات: النسبة والنوع ثابتان. أضف رمزاً جديداً لنسبة جديدة.',
    drawerHint: 'النسب وخانات إقرار VAT 201 بيانات، لذا يمكن تصحيحها دون إصدار جديد من التطبيق.',
    ratePercent: 'النسبة (%)',
    returnCategoryHint: 'جدول GSTR-1 وسطر GSTR-3B.',
    taxSplit: 'توزيع الضريبة',
    taxSplitHint: 'داخل الولاية: CGST + SGST؛ بين الولايات: IGST.',
    splitNone: 'لا يوجد (صفرية، معفاة، خارج GST، صادرات)',
    vat201Box: 'خانة إقرار VAT 201',
    description: 'الوصف',
    applies: {
      sales: 'المبيعات',
      purchases: 'المشتريات',
      both: 'المبيعات والمشتريات',
    },
    kind: {
      standard: 'خاضع للنسبة الأساسية',
      zero: 'خاضع لنسبة الصفر',
      exempt: 'معفى',
      outOfScope: 'خارج نطاق الضريبة',
      reverseCharge: 'الاحتساب العكسي',
    },
    gstCategory: {
      TAX: 'خاضع للضريبة',
      EXP: 'تصدير (نسبة صفرية)',
      NIL: 'بنسبة صفرية (Nil)',
      EXEMPT: 'معفى',
      NONGST: 'خارج نطاق GST',
      RCM: 'الاحتساب العكسي',
    },
    box: {
      b1: '1a–1g · التوريدات الخاضعة للنسبة الأساسية (حسب الإمارة)',
      b2: '2 · المبالغ المستردة للسياح',
      b3: '3 · التوريدات الخاضعة لآلية الاحتساب العكسي',
      b4: '4 · التوريدات الخاضعة لنسبة الصفر',
      b5: '5 · التوريدات المعفاة',
      b6: '6 · السلع المستوردة إلى دولة الإمارات',
      b7: '7 · تعديلات على السلع المستوردة',
      b9: '9 · النفقات الخاضعة للنسبة الأساسية',
      b10: '10 · الاحتساب العكسي (قابل للاسترداد)',
    },
  },
  eInvoicing: {
    title: 'الفوترة الإلكترونية',
    description: 'الفواتير والإشعارات الدائنة المرسلة عبر مزوّد الخدمة، وما يحتاج إلى تصحيح.',
    offTitle: 'الفوترة الإلكترونية غير مفعّلة لهذه الشركة',
    offHint: 'يفعّلها محاسبك من إعدادات الشركة، في تبويب المبيعات.',
    companySettings: 'إعدادات الشركة',
    statusLabel: 'الحالة',
    searchPlaceholder: 'البحث بالرقم أو العميل أو المرجع',
    searchLabel: 'البحث في الفواتير الإلكترونية',
    loadError: 'تعذّر تحميل الفواتير الإلكترونية',
    noExceptions: 'لا توجد استثناءات',
    noExceptionsHint: 'قُبلت كل فاتورة إلكترونية أو هي في طريقها.',
    noMatch: 'لا توجد فواتير إلكترونية مطابقة لهذه التصفية',
    col: {
      date: 'التاريخ',
      number: 'الرقم',
      customer: 'العميل',
      total: 'الإجمالي',
      einvoice: 'الفاتورة الإلكترونية',
      details: 'التفاصيل',
      lastUpdate: 'آخر تحديث',
      action: 'الإجراء',
    },
    creditNote: 'إشعار دائن',
    invoice: 'فاتورة',
    deliveryFailed_zero: 'فشل الإرسال: {{error}}',
    deliveryFailed_one: 'فشل الإرسال مرة واحدة: {{error}}',
    deliveryFailed_two: 'فشل الإرسال مرتين: {{error}}',
    deliveryFailed_few: 'فشل الإرسال {{count}} مرات: {{error}}',
    deliveryFailed_many: 'فشل الإرسال {{count}} مرةً: {{error}}',
    deliveryFailed_other: 'فشل الإرسال {{count}} مرة: {{error}}',
    retrying: 'جارٍ إعادة المحاولة: {{error}}',
    toastResubmitted: 'أُعيد إرسال {{number}}.',
    toastQueued: 'أُعيد إدراج {{number}} في قائمة الإرسال.',
    view: 'عرض',
  },
  einvoice: {
    resubmit: 'إعادة الإرسال',
    retryDelivery: 'إعادة محاولة الإرسال',
    providerUnavailable: 'مزوّد الخدمة غير متاح',
    status: {
      needsAttention: 'يحتاج إلى متابعة',
      notRequired: 'غير مطلوبة',
      pending: 'قيد الانتظار',
      submitted: 'مُرسلة',
      accepted: 'مقبولة',
      rejected: 'مرفوضة',
    },
    filter: {
      exceptions: 'الاستثناءات',
      all: 'الكل',
    },
    legalId: {
      TL: 'الرخصة التجارية',
      EID: 'الهوية الإماراتية',
      PAS: 'جواز السفر',
      CD: 'قرار مجلس الوزراء',
    },
    event: {
      queued: 'أُدرجت في قائمة الإرسال عند الاعتماد',
      approvedBy: 'اعتمدها {{name}}',
      notRequired: 'غير مطلوبة',
      built: 'أُنشئت الفاتورة الإلكترونية',
      builtVersion: 'أُنشئت الفاتورة الإلكترونية (الإصدار {{version}})',
      passed: 'اجتازت التحقق',
      passedWithWarnings_zero: 'اجتازت التحقق دون تحذيرات',
      passedWithWarnings_one: 'اجتازت التحقق مع تحذير واحد',
      passedWithWarnings_two: 'اجتازت التحقق مع تحذيرين',
      passedWithWarnings_few: 'اجتازت التحقق مع {{count}} تحذيرات',
      passedWithWarnings_many: 'اجتازت التحقق مع {{count}} تحذيراً',
      passedWithWarnings_other: 'اجتازت التحقق مع {{count}} تحذير',
      validationErrors_zero: 'لا توجد أخطاء تحقق',
      validationErrors_one: 'خطأ تحقق واحد',
      validationErrors_two: 'خطآن في التحقق',
      validationErrors_few: '{{count}} أخطاء تحقق',
      validationErrors_many: '{{count}} خطأً في التحقق',
      validationErrors_other: '{{count}} خطأ في التحقق',
      validationFailed: 'رُفضت عند التحقق',
      submitted: 'أُرسلت إلى مزوّد الخدمة',
      submittedVersion: 'أُرسلت إلى مزوّد الخدمة (الإصدار {{version}})',
      reference: 'المرجع {{reference}}',
      deliveryFailed: 'فشلت محاولة الإرسال رقم {{attempt}}',
      nextTry: 'المحاولة التالية {{when}}',
      noMoreRetries: 'لا مزيد من المحاولات التلقائية',
      accepted: 'مقبولة',
      rejected: 'رفضها مزوّد الخدمة',
      resubmitted: 'أُعيد إرسالها',
      resubmittedBy: 'بواسطة {{name}}. يُنشأ إصدار جديد من بيانات الفاتورة والعميل الحالية.',
      resubmittedText: 'يُنشأ إصدار جديد من بيانات الفاتورة والعميل الحالية.',
      retried: 'أُعيدت محاولة الإرسال',
      by: 'بواسطة {{name}}',
      statusCheckFailed: 'فشل التحقق من الحالة',
    },
    panel: {
      title: 'الفاتورة الإلكترونية',
      lockedInvoice: 'لم يعد بالإمكان تعديل هذه الفاتورة أو إلغاؤها؛ صحّحها بإشعار دائن.',
      lockedCreditNote: 'لم يعد بالإمكان تعديل هذا الإشعار الدائن أو إلغاؤه؛ صحّحه بإشعار دائن.',
      timeline: 'السجل الزمني',
      notRequired: 'لا تلزم فاتورة إلكترونية لهذا المستند.',
      accepted: 'قبلها مزوّد الخدمة، المرجع {{reference}}.',
      submitted: 'أُرسلت، المرجع {{reference}}؛ بانتظار النتيجة.',
      seeTimeline: 'راجع السجل الزمني لمعرفة السبب',
      needsAttention_zero: 'فشل الإرسال ({{error}}). أعد المحاولة عند عودة مزوّد الخدمة.',
      needsAttention_one: 'فشل الإرسال مرة واحدة ({{error}}). أعد المحاولة عند عودة مزوّد الخدمة.',
      needsAttention_two: 'فشل الإرسال مرتين ({{error}}). أعد المحاولة عند عودة مزوّد الخدمة.',
      needsAttention_few:
        'فشل الإرسال {{count}} مرات ({{error}}). أعد المحاولة عند عودة مزوّد الخدمة.',
      needsAttention_many:
        'فشل الإرسال {{count}} مرةً ({{error}}). أعد المحاولة عند عودة مزوّد الخدمة.',
      needsAttention_other:
        'فشل الإرسال {{count}} مرة ({{error}}). أعد المحاولة عند عودة مزوّد الخدمة.',
      retrying: 'فشل الإرسال؛ ستتم إعادة المحاولة.',
      retryingAt: 'فشل الإرسال؛ ستتم إعادة المحاولة في {{when}}.',
      queued: 'في قائمة الإرسال؛ تُنشأ وتُدقَّق وتُرسل خلال دقيقة.',
      downloadXml: 'تنزيل XML',
      toastResubmitted: 'أُعيد إرسال {{number}}. يُنشأ إصدار جديد من البيانات الحالية.',
      toastRequeued: 'أُعيد إدراج {{number}} في قائمة الإرسال.',
    },
    timeline: {
      titleInvoice: 'الفاتورة الإلكترونية للفاتورة {{number}}',
      titleCreditNote: 'الفاتورة الإلكترونية للإشعار الدائن {{number}}',
      reference: 'مرجع مزوّد الخدمة {{reference}}.',
      description: 'تُحفظ كل خطوة، مع كل إصدار تم إنشاؤه.',
      fixAndResubmit: 'صحّح ما يلي وأعد الإرسال',
      providerSaid: 'ردّ مزوّد الخدمة',
      versions: 'الإصدارات',
      version: 'الإصدار {{version}}',
      builtPassed: 'أُنشئ في {{when}} · اجتاز التحقق',
      builtErrors_zero: 'أُنشئ في {{when}} · لا توجد أخطاء تحقق',
      builtErrors_one: 'أُنشئ في {{when}} · خطأ تحقق واحد',
      builtErrors_two: 'أُنشئ في {{when}} · خطآن في التحقق',
      builtErrors_few: 'أُنشئ في {{when}} · {{count}} أخطاء تحقق',
      builtErrors_many: 'أُنشئ في {{when}} · {{count}} خطأً في التحقق',
      builtErrors_other: 'أُنشئ في {{when}} · {{count}} خطأ في التحقق',
    },
  },
};
